import http from '../utils/http';
import i18n from '@/main';
import axios from 'axios';
import { WarehouseTypeEnum } from '@/modules/warehouse/constants/WarehouseTypeEnum';

const URL_BASE = 'armazem';

export default {
    getAllWarehouses(typeList) {
        if (!typeList || typeList.length === 0) {
            typeList = [WarehouseTypeEnum.SILO, WarehouseTypeEnum.PORTO];
        }
        let body = {
            tiposArmazem: typeList
        };
        return http.post({
            url: `${URL_BASE}/buscar-armazem`,
            data: body,
            lockScreen: false
        });
    },
    getInvoicesByFilter(body, page, size) {
        return http.post({
            url: `${URL_BASE}/buscarNotasPaginadoFiltro?page=${page}&size=${size}`,
            data: body,
            lockScreen: false
        });
    },
    getTotalizers() {
        return http.get({
            url: `${URL_BASE}/totalizadores`,
            lockScreen: false
        });
    },
    getWarehousesPaginated(body, page, size) {
        return http.post({
            url: `${URL_BASE}/buscar-armazem-paginado?page=${page}&size=${size}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosArmazens')
        });
    },
    getWarehousesByName(searchText) {
        return http.get({
            url: `${URL_BASE}/buscar-armazem-por-nome/${searchText}`,
            lockScreen: false
        });
    },
    getWarehouseInformation(id) {
        return http.get({
            url: `${URL_BASE}/resumo/${id}`,
            lockScreen: false
        });
    },
    getWarehouseTerritories(idSaldo, page, size) {
        return http.get({
            url: `${URL_BASE}/${idSaldo}/territorios?page=${page}&size=${size}`,
            lockScreen: false
        });
    },
    async uploadWarehousesSpreadsheet(file) {
        const formData = new FormData();
        formData.append('file', file);
        const url = `${process.env.VUE_APP_HTTP_PATH}/${URL_BASE}/inserir-lote`;

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    validateWarehouseDeletion(id) {
        return http.get({
            url: `${URL_BASE}/${id}/validar-exclusao`,
            lockScreen: false
        });
    },
    deleteWarehouse(id, justificativa) {
        return http.post({
            url: `${URL_BASE}/${id}/excluir`,
            data: { justificativa },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.carregando')
        });
    },
    getWarehouseByCompanyFiltered(body, page, size) {
        return http.post({
            url: `${URL_BASE}/buscar-com-empresa?page=${page}&size=${size}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosInstalacoes')
        });
    }
};
